export default "__VITE_ASSET__Ce1C8VRI__"